class AuthService {
    constructor ( initialData ) {
        this.currentIdentity = null;
        this.initialized = null;
        this.lastCheck = null;
        this.identityChangeCallback = null;
        this.stateChangeCallback = null;
        this.getCurrentIdentity = this.getCurrentIdentity.bind(this);
        this.fetchAllExistingDataFromCache = this.fetchAllExistingDataFromCache.bind(this);
        this.setCurrentIdentity = this.setCurrentIdentity.bind(this);
        this.setIdentityChangeCallback = this.setIdentityChangeCallback.bind(this);
        this.setStateChangeCallback = this.setStateChangeCallback.bind(this);
        this.isInitialized = this.isInitialized.bind(this);
        this.checkIdentity = this.checkIdentity.bind(this);
        this.hasIdentity = this.hasIdentity.bind(this);
        this.markInitialized = this.markInitialized.bind(this);
        this.addUserToLocalStorage = this.addUserToLocalStorage.bind(this);
        this.getAvailableUsers = this.getAvailableUsers.bind(this);
        this.initialize = this.initialize.bind(this);
        this.checkCurrentIdentityOnServer = this.checkCurrentIdentityOnServer.bind(this);
        this.setOnInitialized = this.setOnInitialized.bind(this);

        this.identityCheckTimeout = null;
        this.availableUsers = [];

        this.onInitialized = null;

        this.initialize();

        window.addEventListener('storage', () => {
            this.fetchAllExistingDataFromCache();
        });
    }

    markStateChanged(){
        if( this.stateChangeCallback ){
            this.stateChangeCallback();
        }
    }

    setOnInitialized(callback){
        this.onInitialized = callback;
        if( this.initialized  ){
            this.onInitialized();
        }
    }

    async initialize() {
        
        this.fetchAllExistingDataFromCache();
        if( this.currentIdentity ){
            await this.checkCurrentIdentityOnServer();
        }  

        this.initialized = true;
        if(this.onInitialized ) {
            this.onInitialized();
        }
    }

    logoutCurrentUser(){
        
        if(this.currentIdentity){
            this.clearIdentitiesForUser(  this.currentIdentity.user.id );
        }
        this.setCurrentIdentity(null);
        this.markStateChanged();
    }

    clearIdentitiesForUser(id){
        
        for( let i = 0 ; i < this.availableUsers.length ; i++){
            if( this.availableUsers[i].id == id){
                this.availableUsers[i].currentIdentity = null;
                if( window.localStorage ){
                    window.localStorage.setItem('availableUsers' , JSON.stringify( this.availableUsers ) );
                }
                this.markStateChanged();
                break;
            }
        }
        
    }

    fetchAllExistingDataFromCache(){
        
        if(window.localStorage){
            let curIdentityCache = window.localStorage.getItem('currentIdentity');
            if(curIdentityCache){
                let identity = JSON.parse( curIdentityCache );
                if(identity){
                    this.currentIdentity = identity;
                }
            }
            
            let availUsersCache =  window.localStorage.getItem('availableUsers');
            if(availUsersCache){
                let availableUsers = JSON.parse(  availUsersCache );
                if(availableUsers && availableUsers.length ){
                    this.availableUsers = availableUsers;
                }
            }

            this.markStateChanged();  
        }
    }


    startCheckCurrentIdentityOnServerTimeout(){
        
        const startTimeout = this.startCheckCurrentIdentityOnServerTimeout;
        const checkCurrentIdentityOnServer = this.checkCurrentIdentityOnServer;
        this.identityCheckTimeout = setTimeout( async ()=>{
            await checkCurrentIdentityOnServer();
            startTimeout();
        }, 3600 * 5 );
    }

    async checkCurrentIdentityOnServer(){
        
        if( !this.getCurrentIdentity() ){
            return;
        }
        let response =null;
        try { 
             response = await fetch(  '/rest-api/dauth-access-token/status/' + encodeURI( this.currentIdentity.identity.token)     ,
                {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json' ,
                    'Accept': 'application/json'  ,
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            });
        } catch(e){
           return;
        }
         
        if( response.status == 200 ){
            try {
                const tokenData = await response.json();
                if( tokenData.user ){
                    let checkedIdentity = {...this.currentIdentity};
                    checkedIdentity.user.email = tokenData.user.email;
                    checkedIdentity.user.firstname = tokenData.user.firstname;
                    checkedIdentity.user.lastname = tokenData.user.lastname;
                    checkedIdentity.user.managingAccounts = tokenData.user.managingAccounts;
                    checkedIdentity.user.username = tokenData.user.username;
                    checkedIdentity.user.displayLanguage = tokenData.user.checkedIdentity;
                    this.setCurrentIdentity(checkedIdentity);
                    this.markStateChanged();
                    return;

                }
            } catch (error) {
            }
           
        }

        this.setCurrentIdentity(null);
        this.markStateChanged();
    }


    setIdentityChangeCallback(callback){
        this.identityChangeCallback = callback;   
    }

    setStateChangeCallback( callback ){
        this.stateChangeCallback = callback;
    }
    getCurrentIdentity(){
        return this.currentIdentity;   
    }

    addUserToLocalStorage( user , currentIdentity){
        
        if( !user.id || !user.email || !user.email.trim ||  user.email.trim() == ''  ){
            return;
        }
        if( window.localStorage ){
            let availUsersCache =  window.localStorage.getItem('availableUsers');
            let availableUsers = [];
            if( availUsersCache  ){
                const parsedUsers =  JSON.parse( availUsersCache );
                if( parsedUsers && parsedUsers.length > 0  ){
                    availableUsers = [...parsedUsers];
                }
            }
             
            let userFound = false;
            for( let i = 0 ; i < availableUsers.length ; i++ ){
                if(availableUsers[i].id == user.id){
                    userFound = true;
                    availableUsers[i] = {
                        id : user.id  ,
                        email : user.email,
                        username : user.username,
                        firstname : user.firstname ,
                        lastname : user.lastname ,
                        displayLanguage : user.displayLanguage ,
                        avatar : '' , 
                        currentIdentity : currentIdentity ,
                    };
                    break;
                }
                 
            }

            if( !userFound ){
                availableUsers.push( {
                    id : user.id  ,
                    email : user.email,
                    username : user.username,
                    firstname : user.firstname ,
                    lastname : user.lastname ,
                    displayLanguage : user.displayLanguage ,
                    avatar : '' , 
                    currentIdentity : currentIdentity ,
                });
            } 
            
            window.localStorage.setItem('availableUsers' , JSON.stringify( availableUsers ) );
            this.availableUsers = availableUsers;
            this.markStateChanged();
        }
    }

    removeUserFromLocalStorage( userId  ){
        
        if( !userId   ){
            return;
        }
        if( window.localStorage ){
            let availUsersCache =  window.localStorage.getItem('availableUsers');
            let availableUsers = [];
            if( availUsersCache  ){
                const parsedUsers =  JSON.parse( availUsersCache );
                if( parsedUsers && parsedUsers.length > 0  ){
                    availableUsers = [...parsedUsers];
                }
            }
             
            let userFound = false;
            for( let i = 0 ; i < availableUsers.length ; i++ ){
                if(availableUsers[i].id == userId){
                    userFound = true;
                    // remove element from array at index i
                    availableUsers.splice(i, 1);
                    break;
                }
                 
            }
            
            window.localStorage.setItem('availableUsers' , JSON.stringify( availableUsers ) );
            this.availableUsers = availableUsers;
            this.markStateChanged();
        }
    }

    getAvailableUsers(  ){
        return this.availableUsers;
    }

    setCurrentIdentity( identity ) {
        
        this.currentIdentity = identity;
        if(window.localStorage){
            window.localStorage.setItem('currentIdentity' , JSON.stringify( identity ) );
        }
        if( identity ){
            this.addUserToLocalStorage(identity.user , this.currentIdentity.identity);
        }
        
        this.markStateChanged();
        
    }

    isInitialized(){
        return this.initialized;   
    }
    markInitialized(){
        this.initialized = true;   
    }
    hasIdentity(){
        return ( this.currentIdentity != null );
    }

    checkIdentity(){

    }
}

export default AuthService;